import { NavLink } from "react-router-dom";

const AdminSidebar = () => {
    return (
        <aside className="admin-sidebar">

            <nav className="admin-nav">

                <NavLink to="/admin" end>
                    Dashboard
                </NavLink>

                <NavLink to="/admin/users">
                    Users
                </NavLink>

                <NavLink to="/admin/freelancers">
                    Freelancers
                </NavLink>

                <NavLink to="/admin/businesses">
                    Businesses
                </NavLink>

                <NavLink to="/admin/categories">
                    Categories
                </NavLink>

                <NavLink to="/admin/professions">
                    Professions
                </NavLink>

                <NavLink to="/admin/services">
                    Services
                </NavLink>

            </nav>

        </aside>
    );
};

export default AdminSidebar;